import React, { ChangeEvent, useState, Fragment, useEffect } from "react";

import { useAppState } from "../../state";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import vsPngLogo from "./vs-logo.png";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import Snackbar, { SnackbarOrigin } from '@material-ui/core/Snackbar';
import SnackbarContent from "@material-ui/core/SnackbarContent";

import { CircularProgress } from "@material-ui/core";


const useStyles = makeStyles({
    container: {
        height: "100vh",
        background: "#0D122B",
    },
    snackbarStyle: {
        backgroundColor: "orange",
        color: "black"
    },
    twilioLogo: {
        width: "55%",
        display: "block",
    },
    vsLogo: {
        width: "55%",
        display: "block",
    },
    videoLogo: {
        width: "25%",
        padding: "2.4em 0 2.1em",
    },
    paper: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        maxWidth: "460px",
        padding: "2em",
        marginTop: "4em",
        background: "white",
        color: "black",
    },
    button: {
        color: "black",
        background: "white",
        margin: "0.8em 0 0.7em",
        textTransform: "none",
    },
    errorMessage: {
        color: "red",
        display: "flex",
        alignItems: "center",
        margin: "1em 0 0.2em",
        "& svg": {
            marginRight: "0.4em",
        },
    },
});

const theme = createMuiTheme({
    palette: {
        type: "light",
    },
});

export interface State extends SnackbarOrigin {
    open: boolean;
    SnackMessage: string;
}

export default function LandingPage() {
    const classes = useStyles();
    const { getToken, getMeetingInfo, setIsAdmin, setMeetingTitle, guestName, setGuestName, meetingNum, setMeetingNum, setGuestToken } = useAppState();
    //const location = useLocation<{ from: Location }>();
    const [accessCode, setAccessCode] = useState("");
    const [mtgReady, setMtgReady] = useState(false);
    const [recordSetting, setrecordSetting] = useState(false);
    const [mtgLoading, setMeetingLoading] = useState(false);

    const { connect } = useVideoContext();
    const [, setAuthError] = useState<Error | null>(null);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    useEffect(() => {

        let sMeetingNum: string = query.get("id") || '';
        let sAccCode: string = query.get("code") || '';

        if (sMeetingNum !== '' && sAccCode !== '') {
            getMeetingData();
        }
    }, []);

    const [state, setState] = React.useState<State>({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        SnackMessage: '',
    });

    const { vertical, horizontal, open, SnackMessage } = state;

    //"Invalid meeting #"
    const handleClick = (newState: SnackbarOrigin) => () => {
        setState({ SnackMessage: 'Meeting # is valid. Please try again', open: true, ...newState });
    };

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const getMeetingData = () => {

        let sMeetingNum: string = query.get("id") || '';
        let sAccCode: string = query.get("code") || '';

        setMeetingNum(meetingNum !== '' ? meetingNum : sMeetingNum);
        setAccessCode(accessCode !== '' ? accessCode : sAccCode);

        setAuthError(null);
        getMeetingInfo?.(meetingNum !== '' ? meetingNum : sMeetingNum, accessCode !== '' ? accessCode : sAccCode)
            .then((data) => {
                var j = JSON.parse(data);
                setState({ ...state, open: false });

                //console.log(data);

                if (data === null || j.meetingNumber === "" || j.meetingNumber === null) {
                    handleClick({ vertical: 'top', horizontal: 'center' });
                    setMtgReady(false);
                    setState({ ...state, open: true, SnackMessage: 'Meeting is invalid. Please try again.' });
                } else if (j.hasEnded === true) {
                    handleClick({ vertical: 'top', horizontal: 'center' });
                    setMtgReady(false);
                    setState({ ...state, open: true, SnackMessage: 'Meeting is no longer active.' });
                } else {
                    setMeetingTitle(j.title);
                    setMeetingNum(j.meetingNumber);
                    //setrecordSetting(j.recordFlag === 1 ? true : false);
                    setrecordSetting(true);
                    setIsAdmin(j.isAdmin);
                    //ToDo - fix
                    setMtgReady(true);
                }
            })
            .catch((err) => setAuthError(err));
    };

    const showDisplay = (onInit: boolean) => {
        return mtgReady === onInit ? "block" : "none";
    };

    const showRecordNotice = (onInit: boolean) => {
        return recordSetting === onInit ? "block" : "none";
    };

    const showVisibility = (onInit: boolean) => {
        return mtgReady === onInit ? "visibile" : "invisible";
    };

    const meetingLoading = (onInit: boolean) => {
        return mtgLoading === onInit ? "block" : "none";
    };

    const joinMeeting = () => {
        setMeetingLoading(true);
        setAuthError(null);
        getToken(guestName, meetingNum).then((response) => {
            //TODO - validate
            var t = JSON.parse(response);

            //console.log(t);

            setMeetingNum(t.mtg_num);
            setGuestToken(t.token);
            connect(t.token);
        });
    };

    const cancelJoin = () => {
        handleClick({ vertical: 'top', horizontal: 'center' });
        setMtgReady(false);
    };


    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Grid
                    container
                    justify="center"
                    alignItems="flex-start"
                    className={classes.container}
                >
                    <div className="row align-items-center justify-content-center no-gutters min-vh-100">
                        <Paper className={classes.paper} elevation={6}>
                            <section className="section-border border-primary">
                                <div className="container d-flex flex-column">
                                    <div className="row align-items-center justify-content-center no-gutters">
                                        <div className="col-12">
                                            <img
                                                className="rounded mx-auto d-block"
                                                src={vsPngLogo}
                                                width="80"
                                                height="80"
                                                alt=""
                                            />

                                            <div
                                                className={showVisibility(false)}
                                                style={{ display: showDisplay(false) }}
                                            >
                                                <h3 className="mb-0 font-weight-bold text-center mb-3">
                                                    Joining collaboration
                                                </h3>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="input-accessCode"
                                                        placeholder="Meeting #"
                                                        aria-label="Meeting #"
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                            setMeetingNum(e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="input-meetingPwd"
                                                        placeholder="Access Code"
                                                        aria-label="Access Code"
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                            setAccessCode(e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-block btn-primary btn-lg"
                                                    type="button"
                                                    onClick={getMeetingData}
                                                    disabled={!meetingNum.length}
                                                >
                                                    Join
                                                </button>
                                            </div>
                                            <div
                                                className={showVisibility(true)}
                                                style={{ display: showDisplay(true) }}
                                            >
                                                <h3 className="mb-0 font-weight-bold text-center mb-3">
                                                    Join Collaboration
                                                </h3>
                                                <p className="lead text-center"> ID #: {meetingNum}</p>
                                                <p className="lead text-center">
                                                    Please introduce yourself
                                                </p>

                                                <div className="text-center" style={{ display: meetingLoading(true) }}>
                                                    <CircularProgress />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="input-guestName"
                                                        placeholder="Your Name"
                                                        aria-label="Your Name"
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                                            setGuestName(e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <p className="lead text-center" style={{ display: showRecordNotice(true) }}>
                                                    <small>
                                                        This collaboration might be recorded. By joining, you are giving your consent to having your voice/video recorded.
                                                    </small>
                                                </p>
                                                <div className="row">
                                                    <div className="col">
                                                        <button
                                                            className="btn btn-block btn-secondary btn-lg"
                                                            type="button"
                                                            onClick={cancelJoin}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                    <div className="col">
                                                        <button
                                                            className="btn btn-block btn-primary btn-lg"
                                                            type="button"
                                                            onClick={joinMeeting}
                                                            disabled={!guestName.length}
                                                        >
                                                            Join
                                                        </button>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </Paper>
                    </div>
                </Grid>

                <div>
                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        autoHideDuration={5000}
                        open={open}
                        onClose={handleClose}
                        //message={SnackMessage}
                        key={vertical + horizontal} >
                        <SnackbarContent
                            className={classes.snackbarStyle}
                            message={
                                <span id="message-id2">
                                    <div>{SnackMessage}</div>
                                </span>
                            }
                        />
                    </Snackbar>
                </div>

            </ThemeProvider>
        </Fragment>

    );
}
